<div
	class="patient-header__info-group patient-header__info-group--doctor-license patient-header__grow--1"
	*ngIf="doctorInfo$ | async as doctorInfo"
>
	<info-cell
		*ngIf="(showLicenseReadOnly$ | async) && (cannotReassignScan$ | async)"
		class="doctor-license__treated-by"
		[title]="'IntuitivePatient.TreatedBy' | translate"
		[value]="doctorInfo"
	/>
	<rx-select
		*ngIf="(showLicenseReadOnly$ | async) && (canReassignScan$ | async)"
		class="doctor-license__treated-by-dropdown"
		[id]="'treatedByDoctor'"
		[label]="'IntuitivePatient.TreatedBy' | translate"
		[formControl]="treatedByFormControl"
		[options]="doctors$ | async"
		[getOptionName]="getDoctorDisplayName"
	>
	</rx-select>
	<div class="doctor-license-column" *ngIf="(isLicenseEditable$ | async)">
		<info-cell
			class="doctor-license__treated-by"
			[title]="getTreatedByTitle(doctorInfo)"
		/>
		<div class="doctor-license-input-row">
			<div
				class="doctor-license-input-wrapper"
				[class.doctor-license-input-wrapper--error]="licenseFormControl.invalid && licenseFormControl.touched"
			>
				<div class="doctor-license-input-inner">
					<input
						#licenseInput
						class="doctor-license-input"
						type="text"
						[formControl]="licenseFormControl"
						[placeholder]="licenseInputPlaceholder"
						(focus)="isLicenseInputFocused = true"
						(blur)="isLicenseInputFocused = false"
						autocomplete="off"
					/>
					<div
						class="doctor-license-placeholder-overlay"
						*ngIf="
							showRequiredPlaceholder &&
							!licenseFormControl.value?.trim() &&
							!isLicenseInputFocused
						"
					>
						<span class="doctor-license-placeholder-overlay__text">{{
							'DoctorSection.AddLicenseNumber' | translate
						}}</span>
						<span class="doctor-license-placeholder-overlay__asterisk">*</span>
					</div>
				</div>
				<span
					class="doctor-license-input-helper"
					*ngIf="licenseFormControl.invalid && licenseFormControl.touched"
				>
					{{ licenseErrorMessage }}
				</span>
			</div>
			<button
				tlkButton
				variant="primary"
				size="m"
				[disabled]="licenseFormControl.invalid || licenseFormControl.value?.trim() === ''"
				(click)="saveLicense()"
			>
				<tlk-checkmark-empty-icon class="doctor-license-save-button__icon" />
			</button>
		</div>
	</div>
</div>
